import { atomWithStorage } from 'jotai/utils';

export const jobListLayoutAtom = atomWithStorage<'list' | 'wall'>(
  'jobListLayout',
  'wall'
);
